export default __webpack_public_path__ + "static/media/pic1.3399583c.jpg";